<script lang="ts" module>
  import type { CheckoutSdk } from '@athena-lib/Checkout/utils';

  export type LeftToFreeShippingProps = {
    formattedPrice: string;
  };

  export const getLeftToFreeShipping = (
    state: CheckoutSdk['state'],
    formatPrice: (price: number) => string,
  ): LeftToFreeShippingProps | undefined => {
    if (!state) {
      return undefined;
    }

    const { leftToFreeShipping } = state;

    if (leftToFreeShipping === 0 || leftToFreeShipping === null) {
      return undefined;
    }

    return { formattedPrice: formatPrice(leftToFreeShipping) };
  };
</script>

<script lang="ts">
  import { getCommonTranslations } from '@athena-lib/commonTranslationsContext';
  import { Text } from '@athena-lib/Text';

  const { formattedPrice }: LeftToFreeShippingProps = $props();
  const translations = getCommonTranslations();
</script>

<div class="flex items-center justify-between rounded bg-st-green-100 p-4">
  <div class="flex flex-col gap-1">
    <Text size="xsmall" color="dark-green" class="uppercase">{translations.freeShipping}</Text>
    <Text color="dark-green" size="small" bold>{translations.leftToFreeShipping}</Text>
  </div>
  <Text color="dark-green" size="small" bold>{formattedPrice}</Text>
</div>
